module.exports = __webpack_public_path__ + "static/img/topalov.043b823.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/personas/topalov.jpg
// module id = 508
// module chunks = 11